import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's101g-s101m01',
    templateUrl: './s101g-s101m01.component.html'
})
export class S101gS101m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    userid: any = {'value': '________'};
    authind: any = {'value': '_'};
    credind: any = {'value': '_'};
    commnts: any = {'value': '________________________________________'};
    msgln: any = {};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'userid', 'authind', 'credind', 'commnts', 'msgln'];
    public LINES: number[] = [1, 3, 6, 7, 8, 11, 13, 15, 17, 18, 22, 23, 24];

    ngAfterViewInit(): void {
    }
}
